module.exports = __webpack_public_path__ + "media/assets/text_field-c4679b7f96ffdb12a3eb349b33678206.svg";